import { useFetchFromPublicWabunkaApi } from '@/composables/useFetchFromPublicWabunkaApi';
import { fromNearestStationsJson, type NearestStation } from '@/wabunka-src/features/Experience/composables/query/internal/locationDetailsResponse';

// internal（proto 未リリースの一時ローカル定義）を外部コンポーネントへ直接晒さないため、
// 本 query 経由で型を re-export する。proto 型へ移行する際も差し替え箇所を query に閉じ込められる。
export type { NearestStation };

/**
 * 体験詳細「Location Details」モーダル用 — 最寄り駅（最大3件）を wabunka-backend（E-2）から取得する。
 *
 * モーダル開封時のみ課金・ロードする方針のため `immediate: false` の遅延取得とし、開封時に `execute()` を呼ぶ。
 * 配信は backend の DB キャッシュ素読みのみ（Google API は呼ばれない）。座標なし・未キャッシュは空配列。
 */
export const useNearestStationsQuery = (experienceId: Ref<string>) => {
  const path = computed(() => `/experiences/${experienceId.value}/nearestStations`);

  const { data, status, error, execute } = useFetchFromPublicWabunkaApi({
    path,
    options: { server: false, immediate: false, lazy: true },
    converter: fromNearestStationsJson,
  });

  const stations = computed<NearestStation[]>(() => data.value?.items ?? []);

  return { stations, status, error, execute };
};
